module.exports = __webpack_public_path__ + "img/icon34.ab81a7be.png";